<template>
    <div>
        <div class="menu-title">
            背景图管理
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="名称：">
                    <el-input v-model="qo.LIKES_name" placeholder="请输入名称" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column prop="name" label="名称" ></el-table-column>
                    <el-table-column prop="realAvatarUrl" label="图片">
                      <template slot-scope="scope" >
                        <el-image v-if="scope.row.url != null && scope.row.url.length > 0"
                                  style="width: 70px; height: 70px;background-color: #b0b4b9;"
                                  :src="path+scope.row.url"
                                  :preview-src-list="[path+scope.row.url]"
                                  fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" ></el-table-column>
                    <el-table-column label="是否显示" >
                      <template slot-scope="scope">
                        {{scope.row.isShow?'是':'否'}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="80px" :rules="rules" :model="cmd">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="cmd.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="url">
                  <el-upload
                      class="avatar-uploader"
                      action="#"
                      :on-change="handleFileChange"
                      :auto-upload="false"
                      :show-file-list="false">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                  <el-input-number :min="1" :max="99" v-model="cmd.sort"></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示" prop="isShow">
                  <el-radio v-model="cmd.isShow" :label="true">是</el-radio>
                  <el-radio v-model="cmd.isShow" :label="false">否</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';

    var _this;
    export default {
        name: "unitManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_name: '',
                    DESCI_createTime:1,
                    EQS_type:"bg"
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    name: [
                        {required: true, message: '请输入名称'},
                    ],
                    url: [
                      {required: true, message: '请上传图片'},
                    ],
                    sort: [
                      {required: true, message: '请输入排序'},
                    ],
                    isShow: [
                      {required: true, message: '请选择是否显示'},
                    ],
                },
                imageUrl:"",
                path:getFileUrl()
            }
        },
        mounted() {
            _this = this;
            _this.queryData();
        },
        methods: {
            queryData() {
                request({
                    url: '/images/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/images/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        name: "",
                        type:"bg",
                        isShow: true,
                        url:"",
                        sort:99
                    };
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    if(item.url){
                      _this.imageUrl = _this.path + item.url;
                    }else{
                      _this.imageUrl = ""
                    }

                    _this.cmd = JSON.parse(JSON.stringify(item));
                    _this.$refs.cmd.resetFields();
                });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/images/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/images/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
            handleFileChange(file, fileList) {
              this.imageUrl = URL.createObjectURL(file.raw);
              let formData = new FormData();
              formData.append("file", file.raw);
              request({
                url: '/upload/file/'+ this.cmd.type,
                method: 'post',
                data: formData
              }).then(res => {
                _this.cmd.url = res;
              });
            },
        }
    }
</script>

<style  lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
